var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrOdeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 20.5189V18.615H14.9035V20.5189H12.9997ZM11.0958 18.615V13.9035H12.9997V18.615H11.0958ZM18.615 15.4227V11.9997H20.5189V15.4227H18.615ZM16.7112 11.9997V10.0958H18.615V11.9997H16.7112ZM5.38432 13.9035V11.9997H7.28814V13.9035H5.38432ZM3.48047 11.9997V10.0958H5.38432V11.9997H3.48047ZM11.9997 5.38432V3.48047H13.9035V5.38432H11.9997ZM4.67277 7.99969H7.99969V4.67277H4.67277V7.99969ZM3.48047 9.19199V3.48047H9.19199V9.19199H3.48047ZM4.67277 19.3266H8.07664V15.9996H4.67277V19.3266ZM3.48047 20.5189V14.8073H9.26892V20.5189H3.48047ZM15.9996 7.99969H19.3266V4.67277H15.9996V7.99969ZM14.8073 9.19199V3.48047H20.5189V9.19199H14.8073ZM16.7112 20.5189V17.3265H14.8073V15.4227H18.615V18.615H20.5189V20.5189H16.7112ZM12.9997 13.9035V11.9997H16.7112V13.9035H12.9997ZM9.19199 13.9035V11.9997H7.28814V10.0958H12.9997V11.9997H11.0958V13.9035H9.19199ZM10.0958 9.19199V5.38432H11.9997V7.28814H13.9035V9.19199H10.0958ZM5.64392 7.02854V5.64392H7.02854V7.02854H5.64392ZM5.71124 18.2881V16.9035H7.09584V18.2881H5.71124ZM16.9708 7.02854V5.64392H18.3554V7.02854H16.9708Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrOdeIcon);
export default __webpack_public_path__ + "static/media/qr-сode-icon.84ee0fcf6b7f198e0b467ae30502093e.svg";
export { ForwardRef as ReactComponent };